import { render } from "./record_new.vue?vue&type=template&id=63bfd326&scoped=true"
import script from "./record_new.vue?vue&type=script&lang=js"
export * from "./record_new.vue?vue&type=script&lang=js"

import "./record_new.vue?vue&type=style&index=0&id=63bfd326&lang=scss&scoped=scoped"
import "./record_new.vue?vue&type=style&index=1&id=63bfd326&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bfd326"]])

export default __exports__